import React from "react";
/*
 * CSS JAAN-BOOJH KE CaughtBanner ka hi hai — apni copy nahi banayi.
 *
 * Dono banner ek hi cheez hain: wahi gradient background image, wahi shimmer
 * sweep, wahi pill button. Alag module banate to do jagah same values rehti
 * aur ek badalne pe dusra peeche reh jaata. CSS Modules me dusre module ka
 * import bilkul theek hai — class names build pe waise hi hash hote hain.
 */
import styles from "../CaughtBanner/CaughtBanner.module.css";

/*
 * UpgradeBanner — "UPGRADE / More minutes. More calls." wala banner, right me
 * "EXPLORE PLANS ›" button.
 *
 * Ye khud kuch decide nahi karta: button dabne par sirf `onExplorePlans` call
 * karta hai. Host (FastAgentDetails) usme wahi handler bhejta hai jo More
 * Setting ke "Upgrade Agent" pe chalta hai, taaki dono raste HAMESHA ek jaisa
 * behave karein. Agar upgrade ka flow kabhi badle to sirf ek jagah badlega.
 *
 * CaughtBanner ke structure se do cheezein chhod di hain — `eyebrow` (upar
 * wali chhoti line) aur `trend` (↑ 25% vs last week) — kyunki upgrade pitch me
 * unka koi matlab nahi. Baaki classes wahi hain.
 */
const UpgradeBanner = ({
  title = "UPGRADE",
  subtitle = "More minutes. More calls.",
  ctaLabel = "EXPLORE PLANS",
  onExplorePlans,
}) => {
  // Bina handler ke banner ek dead button hai — dikhane ka koi fayda nahi.
  if (typeof onExplorePlans !== "function") return null;

  return (
    <div className={styles.bannerWrapper}>
      <div className={styles.banner}>
        <div className={styles.left}>
          <div className={styles.iconWrap}>
            {/* Bijli ka icon inline SVG hai, /svg file nahi — banner ka
                background gradient dark hai aur yahan sirf ek chhota white
                bolt chahiye tha; naya asset add karne ka matlab nahi. */}
            <svg width="46" height="46" viewBox="0 0 46 46" fill="none" aria-hidden="true">
              <circle cx="23" cy="23" r="23" fill="#6524EB" />
              <path
                d="M25.2 12.5 17 24.6h5.2L20.8 33.5 29 21.4h-5.2l1.4-8.9z"
                fill="#ffffff"
              />
            </svg>
          </div>
          <div className={styles.textBlock}>
            <h2 className={styles.callCount}>{title}</h2>
            <p className={styles.subtext}>{subtitle}</p>
          </div>
        </div>

        <div className={styles.right}>
          <button
            type="button"
            className={styles.detailsBtn}
            onClick={onExplorePlans}
          >
            {ctaLabel} <span className={styles.chevron}><svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M0.604605 9.39861C0.465132 9.26343 0.465132 9.04426 0.604605 8.90908L4.63778 5L0.604604 1.09092C0.465131 0.955741 0.465131 0.736568 0.604604 0.601386C0.744077 0.466205 0.970208 0.466205 1.10968 0.601386L5.3954 4.75523C5.53487 4.89041 5.53487 5.10959 5.3954 5.24477L1.10968 9.39861C0.970208 9.5338 0.744078 9.5338 0.604605 9.39861Z" fill="white" stroke="#6524EB" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeBanner;
